import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { reportWebVitals, initializeAnalytics, trackPageView, trackEvent } from './utils/analytics';
import { environment } from './environment';

import axios from 'axios';

// Initialize analytics
initializeAnalytics();

// Add global Axios interceptor for JWT authentication
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Add global Axios response interceptor for error handling
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (originalRequest && originalRequest.url && originalRequest.url.includes('/auth/refresh')) {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const res = await axios.post('https://keycloak-auth.babydino.co.in/auth/refresh', {}, {
          withCredentials: true // Required to send the refresh_token cookie
        });
        
        if (res.status === 200) {
          const { token } = res.data;
          localStorage.setItem('token', token);
          
          // Update the original request's authorization header
          originalRequest.headers.Authorization = `Bearer ${token}`;
          
          // Retry the original request
          return axios(originalRequest);
        }
      } catch (refreshError) {
        console.warn("Token refresh failed. Redirecting to login...");
      }
      
      // If refresh fails or returns non-200, clear local storage and redirect to login
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login' && window.location.pathname !== '/welcome') {
        localStorage.setItem('intendedDestination', window.location.href);
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Use StrictMode only in development
const AppComponent = import.meta.env.DEV ?
  <React.StrictMode><App /></React.StrictMode> : 
  <App />;

root.render(AppComponent);

// Track page views and performance
reportWebVitals((metric) => {
  // Send performance metrics to analytics
  if (environment.REACT_APP_ENABLE_ANALYTICS) {
    trackEvent('web_vital', {
      name: metric.name,
      value: metric.value,
      id: metric.id
    });
  }
});

// Track initial page view
trackPageView(window.location.pathname);
